<template>
	<b-card>
		<div slot="header">
			<span style="font-size: 15px; font-weight: bold">Упаковать товары</span>
			<div class="card-header-actions">
				<b-badge @click="$router.push('/warehouse-management/item-collect-create')" style="font-size: 15px; cursor: pointer" class="mr-2" variant="primary"><i class="fa fa-plus"/></b-badge>
			</div>
		</div>
		<b-row class="mt-3">
			<b-col>
				<table ref="table" class="table-striped table-bordered table-hover" style="width: 100%">
					<thead>
					<tr>
						<th class="text-center">{{ '№' }}</th>
						<th class="text-center">{{ $t('incomes.create.reg-number') }}</th>
						<th class="text-center">{{ $t('incomes.create.reg-date') }}</th>
						<th class="text-center">{{ $t('inventory.department') }}</th>
						<th class="text-center">{{ $t('client.create.category') }}</th>
						<th class="text-center">{{ '#' }}</th>
					</tr>
					</thead>
					<tbody v-for="(item, index) in items" :key="`table-${index}`">
					<tr>
						<td class="text-center">{{ index+1 }}</td>
						<td class="text-center">{{ item.regNumber }}</td>
						<td class="text-center">{{ item.regDate }}</td>
						<td class="text-center">{{ item.fromDepartmentName }}</td>
						<td class="text-center">{{ item.documentStatus }}</td>
						<td class="text-center">
							<span class="fa fa-eye text-dark" style="cursor: pointer; font-size: 15px" @click="viewItem(item, index)"/>
						</td>
					</tr>
					</tbody>
					<tbody v-if="items.length === 0">
					<tr>
						<td colspan="9" class="text-center"><h4>{{ $t('empty') }}</h4></td>
					</tr>
					</tbody>
				</table>
				<nav class="mt-2">
					<b-pagination :total-rows="total" :per-page="payload.limit" v-model="payload.page" aria-controls="table"/>
				</nav>
			</b-col>
		</b-row>
	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect"
import CollectService from "@/services/collect.service";

export default {
	name: "index",
	components: {Multiselect},
	data() {
		return {
			items: [],
			total: 0,
			departments: [],
			dep: null,
			name: '',
			loading: false,
			depDisable: false,
			payload: {
				page: 1,
				limit: 20
			}
		}
	},
	watch: {
		'payload.page': {
			handler(p) {
				this.getItems();
			}
		}
	},
	methods: {
		getItems() {
			this.loading = true
			let data = {
				page: this.payload.page,
				limit: this.payload.limit
			}
			CollectService.getItem(data).then(res => {
				if (res) {
					this.items = res.data.items
					this.total = res.data.total
				}
				this.loading = false
			})
		},
		viewItem(item, index) {
			this.$router.push(`/warehouse-management/item-convert-view/${item.id}`)
		}
	},
	created() {
		this.getItems();
	}
}
</script>

<style scoped>

</style>
